import { Component, Input } from '@angular/core';
import { BtnComponent } from '../btn.component/btn.component';

@Component({
  selector: 'app-card',
  imports: [BtnComponent],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
    card_img:string = "";  
    card_title:string = "";
    card_text:string = ""
    card_class:string = "";
    card_img_bottom:string = "";  
    card_btn_label:string = "SAIBA MAIS";

    @Input() i_card!:string; 
    @Input() i_type!:string; 

    ngOnInit() {
      
      if (this.i_type == "services") {
        //this.card_class = "card";
        this.card_class = "card product-card reflect-light";

        switch(this.i_card) {
          case "studio": 
              this.card_img = "assets/mock/mods-0012.jpeg";
              this.card_title = "FUNCIONAL FIGHT";
              this.card_text = `
                    Treinos dinâmicos que combinam, <br/> 
                    condicionamento físico, força, <br/>
                    resistẽncia e técnicas de luta.`;
            break;

          case "outsourcing": 
              this.card_img = "assets/mock/mods-002.jpeg";
              this.card_title = "JIU-JITSU";
              this.card_text = `
                    Técnica, estratégia e disciplina. <br/> 
                    Do iniciante ao avançado, para <br/>
                    todas as idades.`;
            break;

          case "security": 
              this.card_img = "assets/mock/mods-003.jpeg";
              this.card_title = "PERSONAL FIGHT";
              this.card_text = `
                    Atendimento individualizado com <br/> 
                    foco nos seus objetivos e na sua <br/>
                    melhor performance.`; 
            break;
        }
      }

      if (this.i_type == "tools") {
        this.card_class = "tool-card " + (this.i_card == "agata" ? this.i_card : ("dbe" + (this.i_card == "courier" ? " courier" : "")));
        this.card_class += " product-card reflect-dark"

        switch(this.i_card) {
          
          case "ana": 
            this.card_img = "assets/logos/ana/triangle.png";
            this.card_title = "AnA";
            this.card_text = `
                Administração inteligente de núcleos de atendimento,<br/> 
                centralizando operações e melhorando a eficiência do suporte
            `;
            break;  

          case "octa": 
            this.card_img = "assets/logos/octa/octa-blue.png";
            this.card_title = "OCTA";
            this.card_text = `
                Plataforma flexível de CMS e CRM para gerenciar conteúdo, 
                pedidos, produtos, fornecedores e clientes de forma integrada
            `;
            break;  

          case "courier": 
            this.card_img = "assets/logos/courier/courier.png";
            this.card_title = "courier";
            this.card_text = `
                Gestão e automação de campanhas de e-mail personalizadas, 
                com foco em engajamento e conversão
            `;
            break;  

          case "agata": 
            this.card_img = "assets/logos/agata/searcheye-300.png";
            this.card_title = "AgAtA";
            this.card_text = "Auditoria de documentos"

            this.card_text = `
                Auditoria e análise inteligente de documentos,<br/> trazendo mais controle, rastreabilidade e segurança da informação
            `;
            break;  

          case "midas": 
            this.card_img = "assets/logos/midas/eth-base.png";
            this.card_title = "midAs";
            this.card_text = `
                  Automação estratégica para operações com ativos digitais, 
                  unindo tecnologia, análise e execução automatizada
                  `; 
            break;  

          case "dbx": 
            this.card_img = "assets/logos/dbx/dbextract-mid.jpg";
            this.card_title = "DBx";
            //this.card_text = "Extração inteligente de dados"
            this.card_text = `
                  Extração, organização e inteligência de dados 
                  para transformar informação em decisões estratégicas
                  `; 
            break;  

        }

      }

      if (this.i_type == "cases") {
        this.card_class = "tool-card cases";
        this.card_btn_label = "VISITAR";

        switch(this.i_card) {
          
          case "newfight": 
            this.card_img = "assets/logos/newfight/newfight-fav.png";
            this.card_title = "NEW FIGHT";
            this.card_text = `
                  Artes marciais & qualidade de vida
                  `; 
            this.card_img_bottom = "assets/logos/newfight/newfight-cross.png";
            break;  

          case "portalize": 
            //this.card_class += " portalize";
            this.card_img = "assets/logos/portalize/logo-space.png";
            this.card_title = "PORTALIZE BR";
            this.card_text = `Gestão inteligente de entregas<br/>`; 
            this.card_img_bottom = "assets/logos/portalize/ig-icon-building.jpg";
            break;  

          case "vemmeteoro": 
            this.card_class += " vm";
            this.card_img = "assets/logos/vemmeteoro/vemmeteoro.png";
            this.card_title = "VEM METEORO";
            this.card_text = `
                  Are you ready ?<br/>
                  `; 
            break;  

          case "crisolimpio": 
            break;

          case "banqueta": 
            break;

          case "vianna": 
            break;

        }

      }

    }

}
